import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
} from '@nextui-org/react';
import React from 'react';
import moment from 'moment';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { viewMessage } from './querys';
import { message } from 'antd';

function ViewNotification({ data, userId, isRead }) {
  const { isOpen, onOpen, onClose, onOpenChange } = useDisclosure();

  const queryClient = useQueryClient();

  //view post
  const { mutate: viewMutation, isLoading } = useMutation({
    mutationFn: viewMessage,
    onError: (error) => {
      console.error('Error view notification:', error);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(['notification']);
    },
  });

  const handleViewAndClose = () => {
    const messageId = data?.messageId;

    if (!messageId || !userId) {
      message.error('Something went wrong');
      return;
    }

    viewMutation({ id: messageId, userId });
    onClose();
  };

  console.log('is red: ', isRead);

  return (
    <>
      <Button
        onPress={onOpen}
        className={`text-btn-color bg-transparent border-none ${isRead ? 'italic text-btn-hover-color opacity-70' : 'text-btn-color opacity-90'}`}
        variant="bordered"
        disableAnimation={true}
        disableRipple={true}
      >
        view
      </Button>

      <Modal
        size="2xl"
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="center"
        isDismissable={false}
        hideCloseButton={true}
        isKeyboardDismissDisabled={true}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                <p className="text-sm md:text-md text-gray-300 capitalize">
                  {data?.type}
                </p>
              </ModalHeader>
              <ModalBody>
                <p className="text-xs md:text-sm text-gray-400">
                  {data?.message}
                </p>
                <p className="flex items-end justify-end text-gray-400 text-xs">
                  {moment(data?.createdAt).format('llll')}
                </p>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="danger"
                  variant="light"
                  onPress={handleViewAndClose}
                  isLoading={isLoading}
                >
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}

export default ViewNotification;
